import React from 'react';
import PropTypes from 'prop-types';
import Portal from './../../common/Portal';

class FileInput extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    onChange: PropTypes.func,
    inputRef: PropTypes.func,
    multiple: PropTypes.bool
  }

  static defaultProps = {
    multiple: true,
    style: {
      position: 'fixed',
      top: -1000,
      left: -1000,
    }
  }

  render() {
    const { style, onChange, inputRef, multiple } = this.props;

    return (
      <div name="FileInput">
        <Portal defaultOpen={true} closeOnEsc={true}>
          <input
            type="file"
            accept='*\*'
            style={style}
            multiple={multiple}
            onChange={onChange}
            ref={inputRef}  />
        </Portal>
      </div>
    );
  }

}

export default FileInput;
